import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";

import "./_Footer.scss"
import { getLabel } from "../../Services/Language/LanguageService";
import { baseLang } from "../../Lang/BaseLang";
import { ConfigContext } from "../../Context/ConfigContext/ConfigContext.js";
import { AuthContext } from "../../Context/AuthContext/AuthContext";
import { Button } from "primereact/button";
import { Sidebar } from 'primereact/sidebar';
import { classNames } from "primereact/utils";
import { changeWebConfig } from "../../API/IT/Users/UserRequests";
import { toastShow } from "../../Services/ToastService";
import { Toast } from "primereact/toast";

import FooterComponent from '../../../Router/FooterComponent'
import { Dialog } from "primereact/dialog";
import Extensiones from "../../../Screen/ERP/Home/Extensiones/Extensiones";
import { descartarNotificacion, getNotificacionesByUser, leerNotificacion } from "../../API/IT/Accesos/AccesosRequests";
import { useNavigate } from "react-router-dom";
import CardNotificaciones from "../Card/CardNotifcaciones";
import { Badge } from "primereact/badge";

const Footer = () => {
    const toast = useRef(null);
    const { config, changeTheme, changeLanguage } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);
    const [showConfig, setShowConfig] = useState(false);
    const [showConfigExt, setShowConfigExt] = useState(false);
    const [showNotificaciones, setShowNotifiaciones] = useState(false);
    const [notificaciones, setNotificaiones] = useState([]);
    const navigate = useNavigate();


    // Funcion para obtener la IP de la maquina desde la API `https://geolocation-db.com/`
    const getData = async () => {
        // TODO PETICION -> FUNCION
        // const promesa = await fetch('https://geolocation-db.com/json/8dd79c70-0801-11ec-a29f-e381a788c2c0')
        // // const promesa = await fetch('https://ip4.seeip.org/json')

        // await promesa.json()

        //     .then((res) => {
        //         setIP(res.IPv4)
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //         setMostrar(true)
        //     })
    }

    const ObtenerNotificaciones = async () => {
        const respuesta = await getNotificacionesByUser(userAuth?.IdUser)
        setNotificaiones(respuesta.filter(i => i?.Leida === false))
    }

    const abrirNavegacion = async(item) => {
        if(item?.URL){
            navigate(`${process.env.REACT_APP_ENV}${item?.URL}`, { replace: true,  state: { Referencia: item.Referencia || null } })
            // await leerNotificacion(item?.IdNotificacion)
            setShowNotifiaciones(false)
        }
    }

    const DescartarNotificacion = async (item) => {
        let IdNotificacion = item?.IdNotificacion
        const resp = await descartarNotificacion(IdNotificacion)      
        toastShow(toast, 'success', 'Descartada', item?.Referencia ? `Notificacion de ${item?.Referencia || ''} fue descartada correctamente.` : 'Notificación descartada correctamente.')  
        ObtenerNotificaciones()
    }


    // UseEffect para obtener los datos de la IP
    useEffect(() => {
        getData();
        ObtenerNotificaciones()
    }, []);

    useEffect(() => {
        if(showNotificaciones){
            ObtenerNotificaciones()
        }
    }, [showNotificaciones]);
    


    return (
        <div className="footer__Box">
            <Toast
                ref={toast}
                position="bottom-center"
            />
            <div className="footer__Container">

                <div className="d-flex align-items-center">
                    <span className={`p-menuitem-icon pi pi-fw pi-user footer_column-icon mx-2`}></span>
                    <small className="footer_column-info">  {getLabel(baseLang, 'user', config.language)}: {`${userAuth.Usuario}`}  </small><br />
                </div>

                <div className="d-flex align-items-center">
                    <span className={`p-menuitem-icon pi pi-fw pi-cog footer_column-icon mx-2`} ></span>
                    <small className="footer_column-info">{getLabel(baseLang, 'rol', config.language)}: {`${userAuth.Rol}`}</small><br />
                </div>


                <div className="d-flex align-items-center">
                    <span className={`p-menuitem-icon pi pi-fw pi-database footer_column-icon mx-2`} ></span>
                    <small className="footer_column-info">{getLabel(baseLang, 'DB', config.language)}: {process.env.REACT_APP_SHORT_NAME}</small>
                </div>
                <div className="d-flex align-items-center">
                    <span className={`p-menuitem-icon pi pi-fw pi-desktop footer_column-icon mx-2`} ></span>
                    <small className="footer_column-info">API: {(process.env.REACT_APP_API_URL).replace('https://were.ppf.com.hn/', '')}</small>
                </div>



            </div>
            <div className="footer_column-UserName" >
                {/* <span className={`p-menuitem-icon pi pi-fw pi-user  footer_column-icon`} style={{ marginLeft: 5 }}></span> */}
                <FooterComponent />
                {/* <small className="footer_column-info">    {`${userAuth.UserName}`}</small> */}
                {/* <div hidden={habilitar} > */}
                {/* </div> */}

                


                {/* <Button
                    icon="pi pi-bell"
                    tooltip={getLabel(baseLang, 'notificaciones', config.language)}
                    tooltipOptions={{position: 'left'}}
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                        setShowNotifiaciones(true);
                    }}
                    text
                /> */}

                <div className="button-badge-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
                    <Button
                        icon="pi pi-bell"
                        tooltip={getLabel(baseLang, 'notificaciones', config.language)}
                        tooltipOptions={{ position: 'left' }}
                        style={{ marginLeft: 10 }}
                        onClick={() => setShowNotifiaciones(true)}
                        text
                    />
                    <Badge
                        value={notificaciones.length}
                        severity="danger"
                        style={{
                            position: 'absolute',
                            right: '0px',
                            zIndex: 1
                        }}
                    />
      
                </div>
                <Button
                    icon="pi pi-phone"
                    tooltip={getLabel(baseLang, 'Extensiones', config.language)}
                    tooltipOptions={{position: 'left'}}
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                        setShowConfigExt(true);
                    }}
                    text
                />

                <Button
                    icon="pi pi-cog"
                    className=""
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                        setShowConfig(true);
                    }}
                    text
                // outlined
                />
            </div>
            <Sidebar visible={showConfig} onHide={() => setShowConfig(false)} position="right" baseZIndex={1000000}>
                <div className="p-d-flex p-flex-column p-ai-center">
                    <h1>{getLabel(baseLang, 'configuracion', config.language)}</h1>
                    <div>
                        <hr />
                        <h2>
                            {getLabel(baseLang, 'idioma', config.language)}
                        </h2>
                        <div className="p-d-flex p-flex-row p-ai-center">
                            <Button
                                // icon="pi pi-globe"
                                className={classNames("p-button-rounded", { "p-button-primary": config.language === 'es' })}
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    changeLanguage('es');
                                }}
                                label="Español"
                                outlined={config.language !== 'es'}
                                text={config.language !== 'es'}
                            />
                            <Button
                                // icon="pi pi-globe"
                                className={classNames("p-button-rounded", { "p-button-primary": config.language === 'en' })}
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    changeLanguage('en');
                                }}
                                label="English"
                                outlined={config.language !== 'en'}
                                text={config.language !== 'en'}
                            />
                        </div>
                    </div>
                    <div className="mt-4">
                        <hr />
                        <h2>
                            {getLabel(baseLang, 'tema', config.language)}
                        </h2>
                        <div className="p-d-flex p-flex-row p-ai-center" >
                            {/* CONFIGURACION TEMA DARK Y LIGTH */}
                            <Button
                                icon="pi pi-moon"
                                className={classNames("p-button-rounded", { "p-button-primary": config.theme === 'Dark' })}
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    changeTheme('Dark');
                                }}
                                label="Dark"
                                outlined={config.theme !== 'Dark'}
                                text={config.theme !== 'Dark'}
                            />
                            <Button
                                icon="pi pi-sun"
                                className={classNames("p-button-rounded", { "p-button-primary": config.theme === 'Light' })}
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    changeTheme('Light');
                                }}
                                label="Light"
                                outlined={config.theme !== 'Light'}
                                text={config.theme !== 'Light'}
                            />
                        </div>
                        <hr />
                    </div>
                    <div className="configSave">
                        {/* boton guardar */}
                        <Button
                            icon="pi pi-save"
                            className={classNames("p-button-rounded")}
                            onClick={async () => {
                                const u = await changeWebConfig(userAuth.IdUser, config);
                                console.log(u)
                                if (u.length > 0) {
                                    localStorage.setItem(process.env.REACT_APP_StorageUser, JSON.stringify(u[0]));
                                    toastShow(toast, 'success', getLabel(baseLang, 'msgConfigGuardada', config.language));
                                    setShowConfig(false);
                                } else {
                                    toastShow(toast, 'error', getLabel(baseLang, 'msgErrorConfig', config.language));
                                }
                            }}
                            label={getLabel(baseLang, 'btnGuardar', config.language)}
                            // outlined
                            severity="success"
                        />
                    </div>

                </div>
            </Sidebar>


            <Dialog visible={showConfigExt} onHide={()=> setShowConfigExt(false)} style={{width:'50%', height: '70%' }} closeOnEscape>
                <Extensiones/>           
            </Dialog>


            <Sidebar header={<h3 style={{marginTop: 5}}>{getLabel(baseLang, 'notificaciones', config.language)}</h3>} visible={showNotificaciones} onHide={() => setShowNotifiaciones(false)} position="right" baseZIndex={1000000} style={{width: '16%'}}>
                <div style={{height: '100%'}}>
                    <div
                        style={{
                            minWidth: "18%",
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: "100%",      
                            overflowY: "auto",    
                            overflowX: "hidden", 
                            padding: 10,
                        }}
                        className="contenidoCard"
                    >
                        {notificaciones.map((item) => (
                            <div key={item.IdNotificacion} onClick={() => abrirNavegacion(item)} style={{alignItems:'center'}}>
                                <CardNotificaciones 
                                    titulo={item?.Title}
                                    contenido={
                                        <div className='pt-1 gap-2' style={{ height: '5vh', color: 'white' }}>
                                            <span>{item.body}</span><br />
                                            <span>Fecha: {new Date(item?.FechaNormal).toLocaleDateString()}</span>
                                        </div>
                                    }
                                    onClose={() =>DescartarNotificacion(item)}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </Sidebar>
        </div>
    )
}


export default Footer;